<template>
  <main role="main" class="container">
    <div class="row">
      <div class="col-xs-12">
        <div v-if="loadingData">
          <img src="/packages/c5box_framework/themes/framework/img/342.GIF" />
        </div>
        <div v-else>
          <div v-if="dayTrips">
            <h2>BLUE HERON RAFTING TRIPS</h2>
            <trip v-for="trip in dayTrips" :trip="trip"></trip>
          </div>
          <div v-else>
            There are no trips for {{ showDate }}
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'DayTrips',
  props: [
    'dayTrips',
    'loadingData',
    'calendarLoaded'
  ],
  data() {
    return {
      showDate: this.$route.params.date,
    }
  },
  watch: {
    $route() {
      this.showDate = this.$route.params.date;
      // get the new data for the new date
      this.$emit('load-day-trips', this.showDate)
    },
  },
  mounted() {
    // get the data for the date
    this.$emit('load-day-trips', this.showDate)
    this.$emit('set-calendar-loaded', false)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/DayTrips.vue